import { Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectDefaultModDetails,
  selectIsGridModAltered,
  selectIsUndoModal,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { makeStyles } from 'tss-react/mui';
import { AssignTimeOffGrid } from './AssignTimeOffGrid';
const useStyles = makeStyles()(theme => ({
  headings: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#333333',
  },
  headingSpace: {
    marginBottom: '12px',
  },
}));

export const AssignTimeOff = () => {
  const { t } = useTranslation();
  const { setValue, register, getValues } = useFormContext();
  register('timeOffRequests');
  const selectedModsDetails = useSelector(selectDefaultModDetails);
  const { classes } = useStyles();
  const isGridModAltered = useSelector(selectIsGridModAltered);
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);

  const updateAssignedField = (
    id: number,
    value: boolean,
    saveModResponse?: { travelerOptionId?: string | number },
  ) => {
    const interimTravelerOptionId =
      selectedModsDetails.travelerOptionId !== 0
        ? selectedModsDetails.travelerOptionId
        : saveModResponse?.travelerOptionId;
    const timeOfflist = getValues('timeOffRequests');
    const updatedValues =
      timeOfflist.length > 0 &&
      timeOfflist.map(item =>
        item.placementTimeOffId === id
          ? {
              ...item,
              assigned: value,
              isModified: value,
              interimPlacementId: value ? selectedModsDetails.placementId : null,
              interimTravelerOptionId: value ? interimTravelerOptionId : null,
            }
          : { ...item },
      );
    setValue('timeOffRequests', updatedValues, { shouldDirty: true });
    dispatch(placementModsAction.setGridModAltered(true));
    return updatedValues;
  };

  useEffect(() => {
    if (isGridModAltered === false) {
      setValue('timeOffRequests', selectedModsDetails.placementTimeOffList);
    }
    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGridModAltered, isUndoModal]);

  return (
    <>
      <div className={classes.headingSpace}>
        <Typography component="span" className={classes.headings}>{`${t(
          'placement.placementMods.assignedTimeOff',
        )}`}</Typography>
      </div>
      <Grid>
        <AssignTimeOffGrid
          timeOffRequests={selectedModsDetails.placementTimeOffList}
          totalCount={selectedModsDetails.totalCount}
          assignedCount={selectedModsDetails.assigned}
          updateAssignedField={updateAssignedField}
        />
      </Grid>
    </>
  );
};
